import React, { Component } from "react";
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import "./style.scss";

export class AnimationSequence extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  finishStep = () => {
    switch(this.props.type) {
      case "DEPOSIT_SOLUTION":
        this.depositSolution();
        break;
      case "LOAD_GELBOX_SOLUTION":
        this.loadGelBoxSolution();
        break;
      case "PREPARE_GELBOX":
        this.prepareGelBox();
        break;
      case "RUN_GELBOX":
        this.runGelBox();
        break;
      case "VISUALISE_GEL":
        this.visualizeGel();
        break;
      case "PIPETTE_PLUNGER":
        this.pipettePlunger();
        break;
      case "PUT_ON_PPE":
        this.putOnPPE();
        break;
      default:
        // code block
    }
  }

  getTitle = () => {
    let title;

    switch(this.props.type) {
      case "DEPOSIT_SOLUTION":
        title = "Pipette Samples";
        break;
      case "LOAD_GELBOX_SOLUTION":
        title = "Load Solution";
        break;
      case "PREPARE_GELBOX":
        title = "Prepare Gel Electrophoresis Box";
        break;
      case "RUN_GELBOX":
        title = "Run Gel Electrophoresis Box";
        break;
      case "VISUALISE_GEL":
        title = "To Visualize Gel You Need To Turn On The UV";
        break;
      case "PIPETTE_PLUNGER":
        title = "Mix Sample";
        break;
      case "PUT_ON_PPE":
        title = "Put on PPE";
        break;
      default:
        // code block
    }

    return title;
  }

  depositSolution = () => {

    let rowMap = {
      "Control 1 (normal positive control)": "Control 1 Thermocycler",
      "Control 2 (mutated positive control)": "Control 2 Thermocycler",
      "Control 3 (no template negative control)": "Control 3 Thermocycler",
      "Control 4 (prokaryotic control DNA negative control)": "Control 4 Thermocycler",
      "Control 1 (Positive Control)": "Control 1 Thermocycler",
      "Control 2 (Positive Control)": "Control 2 Thermocycler",
      "Control 3 (Negative Control)": "Control 3 Thermocycler",
      "Control 4 (DNA Negative Control)": "Control 4 Thermocycler"
    }

    let solMap = {
      "1μl extracted human DNA": "Extracted Human DNA",
      "1μl normal gene X control DNA": "Normal Gene X Control DNA",
      "1μl shorter gene X": "Shorter Gene X Control DNA",
      "1μl DNAse free water": "DNase Free Water",
      "1μl prokaryotic control DNA": "Prokaryotic Control DNA"
    }

    this.props.tableData.data.forEach((row, rowIndex)=>{
      if(rowIndex !== 0){

        let itemProps = this.props.solutions.find((solution) => solution.type === rowMap[row[0]]);
        let solutions = [];

        // Set the template DNA based off the Protocol Table
        if(row[1] !== null){
          solutions.push({
            [solMap[row[1]]]: 1
          })
        }

        // Set the Master Mix volume
        if(row[2] !== null){

          let solutionsArr = Object.keys(this.props.solutions[6].solutions);
          let totalVol = this.props.solutions[6].volume;

          // Master Mix is ID 7
          solutionsArr.forEach((solution, index)=>{

            let solutionVolume = this.props.solutions[6].solutions[solution];

            solutions.push({
              [solution]: (row[2] * (solutionVolume / totalVol))
            })
          })
        }

        // Set the dH20 volume
        // if(row[4] !== null){
        //   solutions.push({
        //     "DNase Free Water": parseFloat(row[4], 10)
        //   })
        // }

        if(typeof itemProps !== 'undefined' && Object.keys(solutions).length > 0){
          this.props.incSolution({
            id: itemProps.id,
            solutions: solutions,
            fragments: {},
          })
        }
      }
    })

    // this.props.decSolution({
    //   id: solutionID,
    //   type: solutionObj.type,
    //   amount: volume
    // });

    this.props.showModal({
      display: false
    })
  }
  loadGelBoxSolution = () => {
    this.props.showModal({
      display: false
    })
    this.props.loadDNALadder(true)
  }
  prepareGelBox = () => {
    this.props.prepareGelBox(true)
    this.props.showModal({
      display: false
    })
  }
  runGelBox = () => {
    this.props.showModal({
      display: false
    })
    this.props.runGel(true)
  }
  visualizeGel = () => {
    this.props.showModal({
      display: false
    })
    this.props.visualizeGel(true)
  }
  pipettePlunger = ()=>{
    this.props.setSolutionMixed({
      id: this.props.id,
      mixed: true
    })
    this.props.showModal({
      display: false
    })
  }

  putOnPPE = ()=>{
    this.props.showModal({
      display: false
    })
  }


  render() {

    return (
      <div className="modal-section deposit-solution" style={{
        width: "calc(100% - 0px)",
        //height: "650px",
        margin: "auto"
      }}>
        <div className="modal-header">
          <h2>{this.getTitle()}</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner">
            <Player
              //alt='content-item'
              //className={props.className}
              autoplay
              controls
              src={this.props.animation}
            >
              <Controls visible={true} buttons={['play', 'stop', 'repeat']} />
            </Player>
          </div>
        </div>

        <div className="modal-footer">

          <div style={{
            justifySelf: "flex-start",
            marginRight: "auto"
          }}>
            <p>Note: You don't have to watch the full animation.</p>
          </div>
          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={()=>this.finishStep()}>
              Finish step
          </button>
        </div>

      </div>

    );
  }
}
